// based on rc-tooltip 3.7.3
import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-tooltip/index.js
// module id = null
// module chunks = 